import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { pageTitle } from '../utils/events';
import { gtagService } from '../services/gtag-service';

const Gtag = () => {
  const location = useLocation();

  useEffect(() => {
    gtagService.dispatch({
      eventName: 'page_view',
      input: {
        pagePath: location.pathname,
        screenName: location.pathname,
        pageTitle: pageTitle[location.pathname]
      }
    });
  }, [location]);

  return null;
};

export default Gtag;
